import React, { createContext, useContext } from 'react';
import { usePollingManager } from './usePollingManager.jsx';
import { 
  POLLING_TYPES,
  PROJECT_PROCESSING_STATUSES,
  SEGMENT_PROCESSING_STATUSES,
  PROJECT_FINAL_STATUSES,
  SEGMENT_FINAL_EXTRACT_STATUSES,
  SEGMENT_FINAL_RENDER_STATUSES 
} from './types';

// Create context
const PollingContext = createContext({
  registerPolling: () => {},
  unregisterPolling: () => {},
  getItemStatus: () => ({}),
  isPolling: () => false,
  subscribeToStatus: () => () => {},
});

/**
 * Provider component that manages polling for tasks
 * 
 * @param {Object} props Component props
 * @param {React.ReactNode} props.children Child components
 * @param {string} props.projectId Current project ID (optional, will use route param if not provided)
 */
export function PollingProvider({ children, projectId }) {
  const pollingManager = usePollingManager(projectId);
  
  return (
    <PollingContext.Provider value={{
      ...pollingManager,
      POLLING_TYPES,
    }}>
      {children}
    </PollingContext.Provider>
  );
}

/**
 * Hook to use the polling context
 * @returns {Object} Polling context value with methods to register, unregister, and query polling status
 */
export function usePolling() {
  const context = useContext(PollingContext);
  if (!context) {
    throw new Error('usePolling must be used within a PollingProvider');
  }
  return context;
}

// Export types and constants
export { 
  POLLING_TYPES,
  PROJECT_PROCESSING_STATUSES,
  SEGMENT_PROCESSING_STATUSES,
  PROJECT_FINAL_STATUSES,
  SEGMENT_FINAL_EXTRACT_STATUSES,
  SEGMENT_FINAL_RENDER_STATUSES 
} from './types'; 